{
  "MENU_TOGGLE": "Menu",
  "DROPDOWN_MENU": {
    "SIGNED_IN_AS": "Signed in as",
    "IMPERSONATING_USER_AS": "as",
    "EMAIL_IS_VERIFIED": "Your email address is verified",
    "EMAIL_IS_UNVERIFIED": "Your email address is not verified",
    "SWITCH_USER": "Switch user"
  },
  "NOTIFICATIONS": {
    "TITLE": "Notifications",
    "LOAD_FAILURE": "Failed to load notifications.",
    "NO_NOTIFICATIONS": "You have no notifications.",
    "ACTIONS": {
      "SETTINGS": "Settings",
      "MARK_ALL_AS_READ": "Mark all as read",
      "MARK_AS_READ": "Mark as read",
      "MARK_AS_UNREAD": "Mark as unread",
      "TURN_OFF_NOTIFICATION": "Turn off notification",
      "TURN_ON_NOTIFICATION": "Turn on notification",
      "DISCARD_CHANGES": "Discard changes",
      "SAVE": "Save",
      "UNDO": "Undo",
      "DISMISS": "Dismiss",
      "CONFIGURE_SMB_SETTING": "Configure notification settings for this account."
    },
    "EMPTY_NOTIFICATION_SETTING": {
      "TITLE": "No notification settings available",
      "TEXT": "Notifications are currently turned off. To start receiving notifications, contact your account representative."
    },
    "UNSUBSCRIBE_TEXT": "You will no longer receive this notification.",
    "SUBSCRIBE_TEXT": "You will now receive this notification.",
    "SETTINGS": {
      "ALL_DISABLED": "All notifications have been disabled. Emails will not be received.",
      "NO_ACCESS": "You don't have access to any settings.",
      "LOAD_FAILURE": "Failed to load settings. Please try again.",
      "ACTIVITY_SETTINGS_DESCRIPTION": "These notifications are currently in beta, you can view and update your activity notification settings <a href=\"{{ url }}\">here</a>",
      "BETA": "BETA",
      "DESCRIPTION": {
        "SOME_ON": "Some on",
        "ALL_ON": "All on",
        "ALL_OFF": "All off",
        "ALL_EVENTS": "All events",
        "ALL_EVENTS_TOOLTIP": "Notify me for all events of this type.",
        "ONLY_MY_EVENTS": "Only my events",
        "ONLY_MY_EVENTS_TOOLTIP": "Notify me only when an event directly involves me."
      },
      "MEDIUMS": {
        "APP": "App",
        "EMAIL": "Email",
        "UNKNOWN": "Unknown"
      },
      "UNAVAILABLE": "notifications are not available",
      "SNACKBAR": {
        "UPDATED": "Your notification settings were updated.",
        "FAILURE": "An error occurred while trying to load your notification settings, please try again.",
        "SAVE_FAILURE": "An error occurred trying to save your notification settings, please retry."
      }
    },
    "ALLOW_PUSH_NOTIFICATIONS": "Allow push notifications",
    "MOBILE_NOTIFICATIONS_DISABLED": "Your push notifications are disabled, enable them in your device settings.",
    "TYPES": {
      "ABANDONED_SHOPPING_CART_NOTIFICATION": {
        "NAME": "Abandoned Shopping Cart Notification",
        "DESCRIPTION": "User's will receive this notification when they abandon their shopping cart. A user is considered to have abandoned their shopping cart when they update it by adding or removing items but don't checkout."
      },
      "ACCOUNT_TEMPLATE_APPLIED": {
        "NAME": "Account Template Applied",
        "DESCRIPTION": "After an account-template is applied to the target namespace"
      },
      "ADDRESS_VALIDATION_ERRORS": {
        "NAME": "Address Validation Errors",
        "DESCRIPTION": "Get a notification when Listing Sync Pro or Listing Distribution is activated and the business address has errors"
      },
      "ADDRESS_VALIDATION_SUGGESTION": {
        "NAME": "Address Validation Suggestion",
        "DESCRIPTION": "Get a notification when Listing Sync Pro or Listing Distribution is activated and the business address has suggested improvements"
      },
      "AUTOMATA_AUTOMATION_ERRORS": {
        "NAME": "Automation Error Notifications",
        "DESCRIPTION": "Notifications sent to subscribers of an automation when there are errors when running that automation"
      },
      "BULK_ACTION_STATUS": {
        "NAME": "Bulk Action Complete",
        "DESCRIPTION": "Get a notification when a bulk action taken on a list is complete"
      },
      "BULK_PROCESSOR_STATUS": {
        "NAME": "Bulk Processor Complete",
        "DESCRIPTION": "Get a notification when a bulk processing task is complete."
      },
      "BUSINESS_CENTER_ACTIVITY": {
        "NAME": "Business Center Activity",
        "DESCRIPTION": "Receive notifications about recent activity."
      },
      "CALENDAR_EVENT_CANCELLED": {
        "NAME": "Calendar Event Cancelled",
        "DESCRIPTION": "Get an event when a user cancels a calendar event"
      },
      "CALENDAR_EVENT_CANCELLED_ADDITIONAL_HOST": {
        "NAME": "Calendar Event Cancelled for additional host",
        "DESCRIPTION": "Get an event when a user cancels a calendar event for additional host"
      },
      "CALENDAR_EVENT_CREATED": {
        "NAME": "Calendar Event Created",
        "DESCRIPTION": "Get a notification when a user creates a new Calendar event"
      },
      "CALENDAR_EVENT_CREATED_ADDITIONAL_HOST": {
        "NAME": "Calendar Event Created for Additional host",
        "DESCRIPTION": "Get a notification when a user creates a new Calendar event when multiple hosts are involved"
      },
      "CALENDAR_EVENT_REMINDER": {
        "NAME": "Calendar Event Reminder",
        "DESCRIPTION": "Reminds users of an upcoming calendar event."
      },
      "CALENDAR_EVENT_REMINDER_ADDITIONAL_HOST": {
        "NAME": "Calendar Event Reminder for additional host",
        "DESCRIPTION": "Reminds users of an upcoming calendar event for additional host."
      },
      "CALENDAR_EVENT_RESCHEDULED": {
        "NAME": "Calendar Event Rescheduled",
        "DESCRIPTION": "Get an event when a user reschedules a calendar event"
      },
      "CALENDAR_EVENT_RESCHEDULED_ADDITIONAL_HOST": {
        "NAME": "Calendar Event Reschedule for additional host",
        "DESCRIPTION": "Reminds users of a rescheduled calendar event for an additional host."
      },
      "CALENDAR_NOT_CONNECTED": {
        "NAME": "Calendar Not Connected",
        "DESCRIPTION": "Get a notification when a meeting is booked, rescheduled or cancelled with no external calendar connection"
      },
      "CALENDLY_DUPE_ACCOUNT": {
        "NAME": "Calendar: Potential Duplicate Account",
        "DESCRIPTION": "Get a notification when an account with the same email address as an existing account schedules a new appointment via the calendar scheduler on the website."
      },
      "CANCELLATION_REQUEST_ASSIGNEE_NOTIFICATION": {
        "NAME": "Cancellation Request Assignee Notification",
        "DESCRIPTION": "This notification is sent to salespeople that are assigned to an account when a Business App user requests the cancellation of a product on the account."
      },
      "CARD_EXPIRES_SOON": {
        "NAME": "Customer Card Expires Soon",
        "DESCRIPTION": "Get a notification when a customer's credit card will expire by the end of the month"
      },
      "CONNECTION_BROKEN_NOTIFICATION": {
        "NAME": "Connection Broken or Disconnected Notification",
        "DESCRIPTION": "Notification on a disconnected connection"
      },
      "CONNECTION_COMPLETED_NOTIFICATION": {
        "NAME": "Connection Completed Notification",
        "DESCRIPTION": "Notification on a connection completed"
      },
      "CONSTANT_CONTACT_BILLING_TIER_CHANGED": {
        "NAME": "Constant Contact Billing Tier Change",
        "DESCRIPTION": "Get a notification when an account transitions between billing tiers in Constant Contact"
      },
      "CREDIT_INCREMENT_PARTNER_NOTIFICATION": {
        "NAME": "vCash Billing Credits",
        "DESCRIPTION": "Get a notification when there is an update to your vCash billing credits"
      },
      "CRM_INTEGRATIONS_NEW_LEAD_CAPTURED": {
        "NAME": "New Lead",
        "DESCRIPTION": "Notify me when a new lead is captured"
      },
      "DEPENDENCY_UPDATE": {
        "NAME": "Task Dependency Update",
        "DESCRIPTION": "Get notified when a dependent task is unlocked"
      },
      "DIGITAL_AGENT_QUESTION_ASKED_NOTIFICATION": {
        "NAME": "Task Manager Question Asked Notification",
        "DESCRIPTION": "An event triggered to send notifications when an SMB asks a question about a fulfillment service"
      },
      "DIGITAL_AGENT_SOCIAL_POST_FAILED_NOTIFICATION": {
        "NAME": "Managed Social Post Failed",
        "DESCRIPTION": "Notifies you when a social post scheduled by you on behalf of a business fails to post to the social network for any reason"
      },
      "DIGITAL_AGENT_TAGGING_EVENT": {
        "NAME": "Task Manager Tagging Notification",
        "DESCRIPTION": "Get notified when you're tagged on a task"
      },
      "DIGITAL_AGENT_VISIBLE_TASK_APPROVAL_NOTIFICATION": {
        "NAME": "Task Manager Visible Task Approval Notification",
        "DESCRIPTION": "An event triggered to send notifications to the task assignee when an SMB approves a task from the project tracker"
      },
      "DIGITAL_AGENT_VISIBLE_TASK_FEEDBACK_NOTIFICATION": {
        "NAME": "Task Manager Visible Task Feedback Notification",
        "DESCRIPTION": "An event triggered to send notifications to the task assignee when an SMB provides feedback on a visible task"
      },
      "EMAIL_DOMAIN_UNVERIFIED": {
        "NAME": "Unverified Email Domain",
        "DESCRIPTION": "Alerts users that their email domain is unverified"
      },
      "EXECUTIVE_REPORT_READY": {
        "NAME": "Executive Report Ready",
        "DESCRIPTION": "Get a notification when a new executive report is ready for viewing"
      },
      "EXPORT_FAILED": {
        "NAME": "Export Failed",
        "DESCRIPTION": "Get notified when an export failed"
      },
      "EXPORT_OPPORTUNITY_PIPELINE_CSV": {
        "NAME": "Sales Opportunities CSV",
        "DESCRIPTION": "Get a notification and link when your CSV is finished building"
      },
      "EXPORT_SUCCESSFUL": {
        "NAME": "Export Complete",
        "DESCRIPTION": "Get a notification when your export file is ready for download"
      },
      "GENERIC_AUTOMATION_NOTIFICATION": {
        "NAME": "Generic Automation Notifications",
        "DESCRIPTION": "Notifications sent by automation actions"
      },
      "GOOGLE_MY_BUSINESS_ANSWER": {
        "NAME": "Google Q&A Answer",
        "DESCRIPTION": "A notification sent whenever a new or updated Google Q&A answer is received"
      },
      "GOOGLE_MY_BUSINESS_QUESTION": {
        "NAME": "Google Q&A Question",
        "DESCRIPTION": "A notification sent whenever a new or updated Google Q&A question is received"
      },
      "GSUITE_SETUP_FAILURE": {
        "NAME": "Google Workspace Setup Reminder",
        "DESCRIPTION": "Get a notification when an account still hasn't completed their Google Workspace setup process after 24 hours"
      },
      "HIGH_PRIORITY_AUTOMATION_NOTIFICATION": {
        "NAME": "High Priority Automation Notifications",
        "DESCRIPTION": "High priority notifications sent by automation actions"
      },
      "HOT_LEAD_NOTIFICATIONS": {
        "NAME": "Hot Lead Notifications",
        "DESCRIPTION": "Get a notification when an account receives a hot lead"
      },
      "IMPORT_FINISHED": {
        "NAME": "CRM Import",
        "DESCRIPTION": "After an import of Contacts/Companies is finished processing"
      },
      "INBOUND_MESSAGE": {
        "NAME": "Inbound Message",
        "DESCRIPTION": "Get a notification when you receive an inbound message from an account"
      },
      "INBOX_MESSAGES": {
        "NAME": "New Message",
        "DESCRIPTION": "Notify me when a new message is received in Conversations"
      },
      "INBOX_NEW_LEAD_CAPTURED": {
        "NAME": "New Lead",
        "DESCRIPTION": "Notify me when a new lead is captured"
      },
      "INBOX_RETURNING_LEAD_CAPTURED": {
        "NAME": "Conversation Update",
        "DESCRIPTION": "Notify me when a new conversation happened with an existing contact"
      },
      "INVOICE_AUTO_GENERATED": {
        "NAME": "Invoice Auto Generated",
        "DESCRIPTION": "Get a notification any time an invoice is automatically generated"
      },
      "INVOICE_PAYMENT_FAILED": {
        "NAME": "Invoice Payment Failed",
        "DESCRIPTION": "Get a notification any time an invoice payment fails"
      },
      "INVOICE_PROCESSING_FAILED": {
        "NAME": "Invoice Processing Failed",
        "DESCRIPTION": "Get a notification when an invoice fails to process."
      },
      "KNOWLEDGE_SOURCE_WEBSITE_SCRAPE_FINISHED": {
        "NAME": "Website Scrape Finished",
        "DESCRIPTION": "Get a notification when a website scrape in the AI knowledge base has finished"
      },
      "MEETING_ANALYSIS_CONVERSATION_ANALYZED": {
        "NAME": "Meeting Summary Ready",
        "DESCRIPTION": "Get a notification when a meeting summary is ready for review"
      },
      "MEETING_STARTING_SOON": {
        "NAME": "Meeting Starting Soon",
        "DESCRIPTION": "Sends a reminder to salespeople 15 minutes before a bookmenow meeting is scheduled to start"
      },
      "NEW_RESELLER": {
        "NAME": "New Reseller",
        "DESCRIPTION": "Get a notification when a partner becomes your reseller"
      },
      "PARTNER_DAILY_ACTIVITY": {
        "NAME": "Daily Activity",
        "DESCRIPTION": "Daily updates on all the important actions your accounts took yesterday."
      },
      "PARTNER_FINANCIAL_HEALTH": {
        "NAME": "Partner Financial Health",
        "DESCRIPTION": "Receives a notification when a Partner's Financial Health has changed state, substate, or in retention status."
      },
      "PARTNER_TASK_VISIBILITY_WAITING_ON_CUSTOMER": {
        "NAME": "Partner Task Visible and Waiting On Customer",
        "DESCRIPTION": "An Event that is triggered when a Task's status is set to 'Waiting On Customer'."
      },
      "PARTNER_VISIBLE_PROJECT_DUE_DATE_CHANGED": {
        "NAME": "Partner Visible Project Due Date Changed",
        "DESCRIPTION": "Notifies partner users that a project tied to one of their orders had its due date changed."
      },
      "PAYOUT_PAID": {
        "NAME": "Vendasta Payments Payout Paid",
        "DESCRIPTION": "This notification is sent when a payout of your Vendasta Payments balance has been processed, and should be visible on your bank statement."
      },
      "PENDING_DOMAIN_SPF_RECORD_BUSINESS_READY_NOTIFICATION": {
        "NAME": "Email Domain SPF Ready Notification",
        "DESCRIPTION": "Sent when the platform detects that your domain's SPF record is ready to be used."
      },
      "PENDING_DOMAIN_SPF_RECORD_PARTNER_READY_NOTIFICATION": {
        "NAME": "Email Domain SPF Ready Notification",
        "DESCRIPTION": "Sent when the platform detects that your domain's SPF record is ready to be used."
      },
      "PLATFORM_ANNOUNCEMENT": {
        "NAME": "Platform Announcement",
        "DESCRIPTION": "Get a notification when there are important announcements about new features or emergencies."
      },
      "PRODUCT_ACTIVATION_FAILURE": {
        "NAME": "Product Activation Failure",
        "DESCRIPTION": "Get a notification when activating a product for one of your accounts fails"
      },
      "PROPOSAL_AWAITING_APPROVAL": {
        "NAME": "Proposal Internal Review Requested",
        "DESCRIPTION": "Notifies when a proposal is sent for review"
      },
      "PROPOSAL_BUILDER_PDF_DOWNLOAD_READY": {
        "NAME": "Proposal Builder PDF Download Ready",
        "DESCRIPTION": "Sent to users of Proposal Builder who request a PDF download of their proposal."
      },
      "PROPOSAL_COMMENT_RECEIVED_V2": {
        "NAME": "Proposal Comment Received",
        "DESCRIPTION": "Notification sent to you when someone else comments on a proposal you are associated with"
      },
      "PROPOSAL_ORDER_APPROVED": {
        "NAME": "Proposal Approved By Customer",
        "DESCRIPTION": "Notify that a proposal was approved by a customer"
      },
      "PROPOSAL_SUBMIT_INTERNAL_REVIEW": {
        "NAME": "Proposal Internal Review Submitted",
        "DESCRIPTION": "Notify the salesperson when a proposal has been reviewed"
      },
      "PROPOSAL_VIEWED": {
        "NAME": "Proposal Viewed",
        "DESCRIPTION": "Notify salespeople when their proposal is viewed"
      },
      "PURCHASE_FAILURE": {
        "NAME": "Credit Card Charge Failure",
        "DESCRIPTION": "Get a notification when billing your credit card fails"
      },
      "PURCHASE_FAILURE_V2": {
        "NAME": "Credit Card Charge Failure",
        "DESCRIPTION": "Get a notification when billing your credit card fails"
      },
      "QUICKBOOKS_INVOICE_PAID": {
        "NAME": "QuickBooks Invoice Paid",
        "DESCRIPTION": "Get a notification when an invoice has been completely paid"
      },
      "QUOTE_ACCEPTED": {
        "NAME": "Quote Accepted",
        "DESCRIPTION": "Notifies the salesperson who created a quote that the prospect has accepted it"
      },
      "RECOMMENDATION_SNAPSHOT_READY": {
        "NAME": "Snapshot Report Ready",
        "DESCRIPTION": "Get a notification when a snapshot report is ready for product recommendations"
      },
      "RETAIL_DISPUTES": {
        "NAME": "Retail Disputes",
        "DESCRIPTION": "Notifies you when a customer makes a dispute against a retail payment and when the dispute is resolved"
      },
      "RETAIL_INVOICE_OVERDUE": {
        "NAME": "Vendasta Payments Invoice Overdue",
        "DESCRIPTION": "Get a notification when a Vendasta Payments invoice becomes overdue"
      },
      "RETAIL_PAYMENT_PARTNER_NOTIFICATION": {
        "NAME": "Retail Payments",
        "DESCRIPTION": "Notifies you of successful and failed retail payments"
      },
      "REVIEW_RESPONSE_UPDATE": {
        "NAME": "Task Review Response Update",
        "DESCRIPTION": "Get a notification when a review response for a Task is approved or changes are requested by a client"
      },
      "SALES_ORDER_ACTIVATION_FAILED": {
        "NAME": "Sales Order Activation Failed",
        "DESCRIPTION": "Get a notification when a sales order fails to successfully activate"
      },
      "SALES_ORDER_CANCELLATION_APPROVED": {
        "NAME": "Sales Orders Cancellation Approved",
        "DESCRIPTION": "Get a notification when cancellation requests are approved for an order"
      },
      "SALES_ORDER_CANCELLATION_DECLINED": {
        "NAME": "Sales Orders Cancellations Declined",
        "DESCRIPTION": "Get a notification when cancellation requests are declined for an order"
      },
      "SALES_ORDER_CANCELLATION_REQUESTED": {
        "NAME": "Sales Order Cancellation Requested",
        "DESCRIPTION": "Get a notification when cancellation requests are sent for an order"
      },
      "SALES_ORDER_CONTRACT_VIEWED": {
        "NAME": "Customer Viewed Pending Contract",
        "DESCRIPTION": "Notifications for a customer viewing their contract while it is waiting for their approval"
      },
      "SALES_ORDER_CREATED": {
        "NAME": "Sales Order Created",
        "DESCRIPTION": "Get a notification when a salesperson creates a new order"
      },
      "SALES_ORDER_EXPIRING": {
        "NAME": "Sales Order Expiring",
        "DESCRIPTION": "Notifications for a sales order that is set to expire"
      },
      "SALES_ORDER_STATUS_CHANGED": {
        "NAME": "Order Changed",
        "DESCRIPTION": "Notifications for individual orders changing status"
      },
      "SALESPERSON_CANCELLATION_REQUEST": {
        "NAME": "Product Cancellation Request",
        "DESCRIPTION": "Sent to salespeople assigned to an account when a Business App user requests the cancellation of a product on the account"
      },
      "SALESPERSON_TASK_VISIBILITY_WAITING_ON_CUSTOMER": {
        "NAME": "Salesperson Task Visible and Waiting On Customer",
        "DESCRIPTION": "Get notified as the account salesperson or order creator when a task is waiting on their SMB"
      },
      "SALESPERSON_VISIBLE_PROJECT_DUE_DATE_CHANGED": {
        "NAME": "Salesperson Visible Project Due Date Changed",
        "DESCRIPTION": "Notifies salespeople that a project tied to one of their orders had its due date changed"
      },
      "SERVICE_CHANGE_REQUEST_RESOLVED": {
        "NAME": "Spend Change Request Resolved",
        "DESCRIPTION": "Get a notification when a spend change request is approved or rejected"
      },
      "SESSION_INVITEE_DEREGISTERED": {
        "NAME": "Session Invitee Deregistered",
        "DESCRIPTION": "Get a notification when a session invitee cancels their meeting invite"
      },
      "SESSION_INVITEE_REGISTERED": {
        "NAME": "Session Invitee Registered",
        "DESCRIPTION": "Get a notification when a user registers for a session calendar event"
      },
      "SESSION_INVITEE_REGISTRATION_FAILED": {
        "NAME": "Session Invitee Registration Failed",
        "DESCRIPTION": "Get a notification when an invitee session booking failed due to constraints"
      },
      "SM_CONTENT_CREATOR_DRAFT": {
        "NAME": "New Social Calendar Draft Post",
        "DESCRIPTION": "Get notified whenever Social Media Manager creates a new draft post that is ready for your review"
      },
      "SM_SCHEDULED_POST": {
        "NAME": "New Social Calendar Scheduled Post",
        "DESCRIPTION": "Get notified whenever the Social Media Manager schedules a new social post"
      },
      "SMB_SERVICE_CANCELLATION_REQUEST": {
        "NAME": "Service Cancellation Request",
        "DESCRIPTION": "Be notified when a product cancellation request is made"
      },
      "SMB_VISIBLE_PROJECT_DUE_DATE_CHANGED": {
        "NAME": "Project Due Date Changed",
        "DESCRIPTION": "Be notified when a project tied to one of your orders had its due date changed"
      },
      "SNAPSHOT_REPORT_READY": {
        "NAME": "Snapshot Ready",
        "DESCRIPTION": "Notifies the Snapshot creator when the Snapshot is ready to view"
      },
      "SOCIALPOST_FEEDBACK_UPDATE": {
        "NAME": "SocialPost Feedback Update",
        "DESCRIPTION": "Get a notification when a SocialPost for a Task is approved or changes are requested by a client"
      },
      "SOCIALSERVICEBROKENTOKEN": {
        "NAME": "Broken Social Connection",
        "DESCRIPTION": "Get a notification when the authentication for a social service breaks or otherwise becomes invalid"
      },
      "SUBSCRIPTION_ACTION_NOTIFICATION": {
        "NAME": "Retail Subscription Action",
        "DESCRIPTION": "Get a notification when an action is required against retail subscriptions to ensure invoicing remains accurate"
      },
      "TASK_ASSIGNEE_UPDATED": {
        "NAME": "Task Assignee Update",
        "DESCRIPTION": "Get a notification when a Task is assigned to you"
      },
      "TASK_DUE_SOON": {
        "NAME": "Task Due Soon",
        "DESCRIPTION": "Get notifications when a task is almost due"
      },
      "TASK_PROJECT_CANCELLATION": {
        "NAME": "Product Deactivated",
        "DESCRIPTION": "Get notified when a product associated with a project is deactivated"
      },
      "TASK_PROJECT_COMPLETED_PC_ADMIN": {
        "NAME": "Project Complete",
        "DESCRIPTION": "Get notified when your fulfillment team completes a project"
      },
      "TASK_VISIBILITY_PROJECT_GENERATED_ACCOUNT_SALESPERSON": {
        "NAME": "Task Project Generated for Account Salesperson",
        "DESCRIPTION": "Get notified as the Account Assigned Salesperson when your fulfillment team creates a project"
      },
      "TASK_VISIBILITY_PROJECT_GENERATED_ORDER_CREATOR_PARTNER_ADMIN": {
        "NAME": "Task Project Generated for Partner Admin",
        "DESCRIPTION": "Get notified as the Partner Admin who created an order when your Fulfillment team creates a project to begin work"
      },
      "TASK_VISIBILITY_PROJECT_GENERATED_ORDER_CREATOR_SALESPERSON": {
        "NAME": "Task Project Generated for Order Creator Salesperson",
        "DESCRIPTION": "Get notified as the Salesperson who created an order when your Fulfillment team creates a project to begin work"
      },
      "TASK_VISIBILITY_WAITING_ON_CUSTOMER": {
        "NAME": "Task Waiting for Your Input",
        "DESCRIPTION": "Be notified when there is a task that is waiting for your input"
      },
      "THE_LOOP_COMMENT_ACTIVITY": {
        "NAME": "Comment Activity",
        "DESCRIPTION": "Get notified when new comments are sent in posts you follow in the Loop"
      },
      "UNVERIFIED_EMAIL_DOMAIN_FINAL_NOTICE": {
        "NAME": "Unverified Email Domain Final Notice",
        "DESCRIPTION": "Alerts users that their email domain is unverified and at risk of automated correction"
      },
      "WORK_ORDER_CREATED": {
        "NAME": "Work Order Created",
        "DESCRIPTION": "Get a notification when a product is activated and creates a work order"
      },
      "WSP_UPTIME_NOTIFY": {
        "NAME": "WSP Uptime Notifier",
        "DESCRIPTION": "Get a notification when a WebsitePro site goes offline"
      }
    },
    "CATEGORIES": {
      "SHOPPING_CART": "Shopping Cart",
      "ACCOUNTS": "Accounts",
      "SALES": "Sales",
      "BILLING": "Billing",
      "TASK": "Task",
      "EXPORT": "Export",
      "AUTOMATIONS": "Automations",
      "BUSINESS_CENTER": "Business Center",
      "VENDOR": "Vendor",
      "CRM": "CRM",
      "EMAIL_CONFIGURATION": "Email Configuration",
      "REPORTING": "Reporting",
      "CONVERSATIONS": "Conversations",
      "KNOWLEDGE": "Knowledge",
      "FULFILLMENT": "Fulfillment",
      "ANNOUNCEMENTS": "Announcements",
      "CONNECTIONS": "Connections",
      "QUOTES": "Quotes",
      "SOCIAL": "Social",
      "SNAPSHOT": "Snapshot",
      "THE_LOOP": "The Loop",
      "WEBSITE": "Website"
    }
  },
  "VBC_NOTIFICATIONS": {
    "GLOBAL_SETTINGS": "Global settings",
    "REPORTS": "Reports",
    "GLOBALLY_DISABLED": "has been globally disabled",
    "MEDIUMS": {
      "IN_APP": "In-app",
      "INSTANT_EMAIL": "Instant email",
      "DIGEST_EMAIL": "Digest email",
      "WEEKLY_EMAIL": "Weekly email",
      "MONTHLY_EMAIL": "Monthly email"
    }
  },
  "COMMON": {
    "POWERED_BY": "Powered by",
    "ERROR_TRY_AGAIN": "An error occurred. Please try again."
  },
  "USER_LANGUAGE_MODAL": {
    "PROMPT_WITH_BROWSER_LANG": "We noticed your browser language is set to <strong>{{browserLang}}</strong>, but your user profile language is set to <strong>{{userLang}}</strong>.",
    "PROMPT_WITHOUT_BROWSER_LANG": "Your user profile language is currently set to <strong>{{userLang}}</strong>.",
    "WANT_TO_SWITCH": "Would you like to confirm your language preferences? We won't ask again for this device.",
    "USE_BROWSER_LANGUAGE": "Switch to {{browserLang}}",
    "CONFIRM_USER_LANGUAGE": "Use {{userLang}}",
    "SEE_ALL_LANGUAGE_OPTIONS": "Select another language"
  },
  "LANGUAGE": {
    "en": "English",
    "fr": "French",
    "fr-ca": "French (Canada)",
    "cs": "Czech",
    "de": "German",
    "nl": "Dutch",
    "es-419": "Spanish (Latin America)",
    "pt": "Portuguese (Brazil)",
    "ru": "Russian",
    "ja": "Japanese",
    "it": "Italian",
    "af": "Afrikaans",
    "he": "Hebrew"
  },
  "SWITCH_LANGUAGE_MODAL": {
    "SWITCH_LANGUAGE": "Switch language",
    "SEARCH_LANGUAGES": "Search languages",
    "TO_SELECT": "to select",
    "TO_NAVIGATE": "to navigate",
    "TO_CLOSE": "to close",
    "HELP_US_TRANSLATE": "Is your preferred language missing from this list? Are the translations incomplete? Help us translate using the Weblate translation portal!",
    "VISIT_TRANSLATION_PORTAL": "Visit Weblate",
    "IMPERSONATION_WARNING": "You are currently impersonating a user. Changing the language will affect your browser, but not change the user's language."
  },
  "EMAIL_VERIFICATION": {
    "TITLE": "Verify your email address",
    "TO_IMPROVE_SECURITY": "To improve security, you'll need to verify your email address to continue using your account.",
    "TO_IMPROVE_SECURITY_WITH_DEADLINE": "To improve security, you'll need to verify your email address before {{ verificationDeadline }} to continue using your account.",
    "CLICK_BELOW": "Click below to send a verification email to the following email",
    "SEND_VERIFICATION_EMAIL": "Send verification email",
    "REMIND_ME_LATER": "Remind me later",
    "EMAIL_SENT": "Email sent",
    "CHECK_YOUR_INBOX": "Check your inbox for an email like this",
    "CONTACT_SUPPORT": "Need help? Contact your support team"
  },
  "USER_SWITCHER_MODAL": {
    "CANCEL": "Cancel"
  },
  "THEME_SWITCHER": {
    "SWITCH_TO_LIGHT": "Switch to light mode",
    "SWITCH_TO_DARK": "Switch to dark mode"
  }
}
